const jQ = jQuery.noConflict();

function showNewsletter() {
    const newsletterShown = localStorage.getItem('newsletterShown');
    const newsletter = jQ('.newsletter-popup');
    if (newsletterShown == null) {
        const time = WP.newsletterTime * 1000;

        setTimeout(() => {
            if (jQ(newsletter).length && !jQ(newsletter).hasClass('active') && jQ('body').hasClass('home')) {
                jQ(newsletter).addClass('active');
            }
            localStorage.setItem('newsletterShown', 1);
        }, time);
    }
}

export default showNewsletter;
